import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import HeaderDefault from '../../components/global/HeaderDefault';
import Footer from '../../components/global/Footer';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  addHeaderContentWrap: PropTypes.bool,
};

const MainLayout = ({ children, className, addHeaderContentWrap }) => (
  <div
    className={classNames({
      'wrapper-main': true,
      [className]: !!className,
    })}
  >
    <HeaderDefault addContentWrap={addHeaderContentWrap} />
    <div className="content-wrap content-wrap-gray">{children}</div>
    <Footer />
  </div>
);

MainLayout.propTypes = propTypes;

export default MainLayout;
